import config from "@/config";
import { BaseResponse } from "@/types/base";
import Axios from "@/utils/Axios";

export const getRefreshCaptcha = (oldCaptchaId: string) => {
  return Axios.get<
    {
      captcha_id: string;
    },
    BaseResponse<{
      captcha_id: string;
      captcha: string;
    }>
  >("/captcha/refresh", { captcha_id: oldCaptchaId }, {}, config.creatorUrl);
};

export const postVerifyCaptcha = (data: { id: string; input: string }) => {
  return Axios.post<{
    captcha_id: string;
    captcha: string;
  }>("/captcha/verify", { captcha_id: data.id, captcha: data.input }, {}, config.creatorUrl);
};
